import { render, staticRenderFns } from "./Uciplus.vue?vue&type=template&id=8a650c50&scoped=true"
import script from "./Uciplus.vue?vue&type=script&lang=js"
export * from "./Uciplus.vue?vue&type=script&lang=js"
import style0 from "./Uciplus.vue?vue&type=style&index=0&id=8a650c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a650c50",
  null
  
)

export default component.exports